<!-- 百度账户 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    批量操作
					<a-menu slot="overlay" @click="handleMenuClick">
						<a-menu-item key="1"> <a-icon type="align-right" />同步历史数据</a-menu-item>
						<a-menu-item key="7"> <a-icon type="align-right" />设置推广内容</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<div class="jl-screen-box">
				<div class="screen-label" style="margin-right: 7px;">精简模式</div>
				<a-switch :checked="jj_checked" default-checked @change="onJJChange" checked-children="开" un-checked-children="关" />
			</div>
			
			
			
			<div style="display: flex;align-items: center;padding-right: 10px;flex-wrap: wrap;">
				<div class="jl-screen-box">
					<a-range-picker style="width:220px;" @change="onChangeDate" :allowClear="false"
					:locale="locale" 
					:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
				</div>
				
				<!-- 选择投手 -->
				<adminSelect @handle-change="handleChangeA"></adminSelect>
				
				<div class="jl-screen-box">
					<a-select
						mode="multiple" 
						style="min-width: 200px;max-width: 600px;"
						placeholder="请选择广告账户"
						:filter-option="false"
						@change="handleChangeB"
						:getPopupContainer="getsPopupContainer" 
						@popupScroll="popupScrollCEshi" 
						showSearch
						allowClear
						@search="selectZhSearch"
						:not-found-content="s_fetching ? undefined : null" 
						@blur="zhBlur"
					  >
						<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
						<a-select-option v-for="(item,index) in selectGgData" :key="item.bd_user_id" :value="item.bd_user_id">
						  {{item.bd_user_name}}
						</a-select-option>
						<a-select-option v-if="loading_more_hint" value="-0-">
							<div style="color:rgb(98, 168, 234)">加载更多中...</div>
							
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_adv_id_input" placeholder="账户ID搜索" allowClear style="width: 190px;"/>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="width: 180px"
						placeholder="请选择渠道内容"
						@change="handleChangeG"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
					  >
						<a-select-option v-for="(value,key) in filterData.content_channel.list" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<!-- 作品选择 -->
				<div class="jl-screen-box">
					<tfBookSelect ref="getTfBook" s_width="260px" s_placeholder="作品" @handleChangeSelect="handleChangeZ"></tfBookSelect>
				</div>
				
				<a-button @click="searchButton('button')" :loading="search_button_loading" class="jl-screen-box" type="primary" icon="search">搜索</a-button>
			</div>
		</div>
	</div>
	</div>
	
	<div style="">
		<BDzhTable @table-th-click="tableThClick" @click-Fzr="clickFzr"
		:rableTitle="rableTitle" 
		:tableShowData="tableShowData" :tableSumData="tableSumData" 
		:table_scroll_width="table_scroll_width" :jj_checked="jj_checked" 
		:indeterminate="indeterminate" :checkAll="checkAll" 
		@click-All-Checkbox="onCheckAllChange" @click-Checkbox="onChangeCheckbox" @sync-zhxx-click="syncZhxxClick" 
		@click-tgnr="clickTgnr"></BDzhTable>
	</div>
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	
	<!-- 批量设置投手 -->
	<a-modal :visible="pl_modal" title="批量设置投手" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的投手</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择投手"
					@change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
					:value="pl_value"
				  >
					<a-select-option v-for="(item,index) in filterData.op_id.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 150px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 12px;">{{item.label}}</div>
					<!-- <div style="color: red;cursor: pointer;">删除</div> -->
					<a-icon @click="delSelectAdmin(index)" type="close-circle" />
				</div>
			</div>
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的账号名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 130px;">{{item.bd_user_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 批量同步历史数据 -->
	<a-modal :visible="sync_modal" title="新建数据同步任务" okType="primary" width="800px"
	  okText="设置" cancelText="取消"
	  @ok="syncOk" @cancel="syncCancel" :confirmLoading="sync_loading">
	    <div style="">
			<div class="screen-box">
				<div class="screen-label">推广日期范围</div>
				<a-range-picker style="width:300px;" 
				@change="onChangeDateSync" 
				@openChange="syncOpenChange"
				@calendarChange="syncCalendarChange"
				:disabledDate="syncDisabledDate"
				:allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime_sync, dateFormat),this.moment(endTime_sync, dateFormat)]" />
			</div>
			
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的账号名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">{{item.bd_user_id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 140px;">{{item.bd_user_name}}</div>
				</div>
			</div>
			
			
		</div>
	</a-modal>
	
	<!-- 设置推广内容 -->
	<tgContentModal :ContentChannel="filterData.content_channel.list" :bookID="filterData.book_id.list" :selectedData="selectedData" 
	:adv_type="3" ref="getTgContent" @set-adv-ok="setAdvOk"></tgContentModal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { BDzhList, BDzhAdv , putDataMenu, accBDSetAdvUser, BDzhSyncAdv, BDsyncPlanReport} from '@/request/api'
import BDzhTable from '@/components/BDtable/BDzhTable.vue'
import adminSelect from '../KSpages/component/adminSelect'
import tgContentModal from '@/views/Market/components/tgContentModal.vue'
import tfBookSelect from '@/components/selectCompont/tfBookSelect.vue'
export default {
	name: 'BDzh_',
	components: {
		BDzhTable, adminSelect, tgContentModal, tfBookSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			jj_checked: true, // 精简模式，默认打开
			selectGgData: [], // 选择广告账户
			s_page: 1,
			s_limit: 100,
			s_bd_user_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			blurGgData: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"账户名称",width:110, sort_status:0, type:"bd_user_name", text_right: false,sort_:90,sort_control: false, show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"投手",width:105, sort_status:0, type:"admin_name", text_right: false,sort_:89,sort_control: false, show_control: true,},
				{title:"推广内容",width:105, sort_status:0, type:"tgnr", text_right: false,sort_:89,sort_control: false, show_control: true,},
				{title:"操作",width:60, sort_status:0, type:"cz", text_right: false,sort_:88,sort_control: false, show_control: true,},
				
				{title:"消耗",width:85, sort_status:0, type:"cost", text_right: true,sort_:87,sort_control: true, show_control: true,},
				{title:"展示数",width:85, sort_status:0, type:"impression", text_right: true,sort_:86,sort_control: true, show_control: false,},
				{title:"ecpm",width:80, sort_status:0, type:"cpm", text_right: true,sort_:85,sort_control: true, show_control: false,},
				{title:"点击数",width:80, sort_status:0, type:"click", text_right: true,sort_:39,sort_control: true, show_control: false,},
				{title:"平均点击单价",width:80, sort_status:0, type:"cpc", text_right: true,sort_:38,sort_control: true, show_control: false,},
				{title:"点击率",width:80, sort_status:0, type:"ctr", text_right: true,sort_:37,sort_control: true, show_control: false,},
				
				{title:"微信调起按钮点击量",width:100, sort_status:0, type:"weiXinAppButtonConversions", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"微信调起按钮点击成本",width:100, sort_status:0, type:"weiXinAppButtonConversionsCost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"微信加粉成功量",width:100, sort_status:0, type:"weixinFollowSuccessConversions", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"微信加粉成功成本",width:100, sort_status:0, type:"weixinFollowSuccessConversionsCost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"微信复制按钮点击量",width:100, sort_status:0, type:"weiXinCopyConversions", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"微信复制按钮点击成本",width:100, sort_status:0, type:"weiXinCopyConversionsCost", text_right: true,sort_:35,sort_control: true, show_control: false,},
				
				{title:"转化数",width:80, sort_status:0, type:"ocpcTargetTrans", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"平均转化成本",width:85, sort_status:0, type:"ocpcTargetTransCPC", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"转化率",width:80, sort_status:0, type:"ocpcTargetTransRatio", text_right: true,sort_:35,sort_control: true, show_control: false,},
				
				{title:"当天总充值金额",width:85, sort_status:0, type:"eff_total_pay_money", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天分成金额",width:85, sort_status:0, type:"eff_total_left_money", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充分成金额",width:85, sort_status:0, type:"eff_total_left_money_fisrt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天总ROI",width:70, sort_status:0, type:"eff_roi", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充ROI",width:80, sort_status:0, type:"eff_roi_first", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"当天订单笔数",width:80, sort_status:0, type:"eff_total_order_cnt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天充值用户数",width:90, sort_status:0, type:"eff_total_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天充值用户成本",width:90, sort_status:0, type:"eff_total_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"ARPU",width:80, sort_status:0, type:"arpu", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户数",width:80, sort_status:0, type:"eff_report_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户成本",width:80, sort_status:0, type:"eff_report_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"账户ID",width:100, sort_status:0, type:"bd_user_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"授权时间",width:140, sort_status:0, type:"created_at", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"开发者账户",width:140, sort_status:0, type:"admin_account_name", text_right: false,sort_:35,sort_control: false, show_control: true,},
			],
			tableShowData: [], // 显示表格内容
			tableSumData: {}, // 总计

			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			r_admin_id: [], // 选择投手
			r_adv_id: [], // 选择的广告账户
			r_adv_id_input: null, // 广告账户id精准搜索
			r_sort_field: "", // 排序参数
			r_sort_type: "", // 排序类型
			r_content_type: undefined, // 渠道内容
			r_book_id: undefined, // 作品id
			
			filterData: {
				op_id:{
					list: [{}],
				},
				content_channel: {
					list: [{}],
				},
				book_id: {
					list: [{}],
				}
			}, 
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量设置投手
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			pl_value: undefined, // 选择框的默认值
			
			// 批量同步历史数据
			sync_modal: false, // 弹窗控制
			sync_loading: false, // 加载中的状态
			disabledCurrent: null,
			startTime_sync: '2022-05-01', // 投放日期-开始时间
			endTime_sync: '2022-06-30', // 投放日期-结束时间
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			if(res.show_control){
				nn = nn + res.width
			}
		})
		that.table_scroll_width = nn + 30 + 30
		if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
		else { that.table_null_width = that.table_scroll_width - 60 }
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		
		// 获取7天前日期
		let date1 = new Date(new Date().getTime() - 604800000);
		let month1
		if(date1.getMonth() + 1 < 10){
			month1 = '0' + (date1.getMonth() + 1)
		}
		else {
			month1 = date1.getMonth() + 1
		}
		let day1
		if(date1.getDate() < 10){
			day1 = "0" + date1.getDate()
		}
		else {
			day1 = date1.getDate()
		}
		// that.startTime = date1.getFullYear() + "-" + month1 + "-" + day1
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		// console.log("date2.getDate();",date2.getDate())
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		that.startTime = date2.getFullYear() + "-" + month2 + "-" + day2; // 默认只获取当天
		// 同步历史数据
		that.startTime_sync = that.endTime
		that.endTime_sync = that.endTime
		
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		BDzhAdv({
			page: 1,
			limit: that.s_limit,
		}).then(res=>{
			console.log('选择',res);
			that.selectGgData = res.data.data.data
			that.blurGgData = res.data.data.data
		})
		
		// 获取作品
		that.$nextTick(()=>{
			that.$refs.getTfBook.getSelectData()
		})
			
		// 搜索
		that.searchButton()
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 精简模式
		onJJChange(e){
			console.log(!e);
			
			this.rableTitle.forEach(res=>{
				// console.log(res);
				if(res.title == "展示数" || res.title == "ecpm" || res.title == "点击数" || res.title == "平均点击单价" || res.title == "点击率" || res.title == "转化率" || res.title == "微信复制按钮点击量" || res.title == "微信复制按钮点击成本" || res.title == "当天总充值金额" || res.title == "当天首充分成金额" || res.title == "当天订单笔数"){
					if(e){ // 精简模式打开
						res.show_control = false
					}
					else {  // 精简模式关闭，显示内容
						res.show_control = true
					}
					
				}
			})
			
			let nn = 0
			this.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					nn = nn + res.width
				}
			})
			this.table_scroll_width = nn + 30 + 30
			
			this.jj_checked = e
			
			// 给母页面的tab传递粘性定位用的参数
			this.$bus.$emit("stickyData", this.table_scroll_width);
		},
		handleChangeA(e){ // 选择投手
			console.log(e);
			// 未设置的选项与其他选项不可以同时选，所以这里要加限制
			if(e.length > 1 && e.indexOf('-1') > -1){
				this.$message.warning('未设置与其他选项不能同时选择');
			}
			else {
				this.r_admin_id = e
			}
		},
		handleChangeB(e){ // 选择广告账户
			console.log(e);
			this.r_adv_id = e
		},
		handleChangeG(e){ // 渠道内容
			this.r_content_type = e
			let eee = 1
			if(e == 3){
				eee = 2
			}
			this.$refs.getTfBook.changeType(eee)
		},
		handleChangeZ(e){ // 作品
			this.r_book_id = e
		},
		
		popupScrollCEshi(e){ // 上拉触底加载更多
			// console.log(e.target.scrollHeight);
			// console.log(e.target.scrollTop);
			// console.log(e.target.scrollHeight - e.target.scrollTop);
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					console.log("上拉触底加载更多");
					BDzhAdv({
						page: that.s_page,
						limit: that.s_limit,
						bd_user_name: that.s_bd_user_name,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.selectGgData 
						that.loading_more_hint = false
						that.selectGgData = data.concat(res.data.data.data) 
						that.s_fetching = false
						that.loading_more_control = true
					})
				}
				
				
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.selectGgData = []
			that.s_fetching = true
			that.s_bd_user_name = e
			
			BDzhAdv({
				page: 1,
				limit: that.s_limit,
				bd_user_name: e,
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.selectGgData = res.data.data.data
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_bd_user_name = '' // 清空
			that.selectGgData = that.blurGgData 
		},
		
		// 同步历史数据-开始
		// 同步历史数据-推广日期范围
		onChangeDateSync(date, dateString) {
			console.log(date, dateString);
			this.startTime_sync = dateString[0]
			this.endTime_sync = dateString[1]
		}, 
		// 弹出日历和关闭日历的回调
		syncOpenChange (status) {
		  // 清空禁用时间段的设置
		  this.disabledCurrent = null
		},
		// 待选日期发生变化的回调
		syncCalendarChange(dates){
			// 获取手动选择的时间段起始值
			this.disabledCurrent = dates[0]
		},
		// 禁止选择范围
		// 1、时间限制范围 开始时间~结束时间不能超过一个月，且禁选超过当前日期时间
		syncDisabledDate (current) {
			// 注释的这段代码的意思是：开始时间~结束时间不能超过7天，且禁选超过当前日期时间
		    // if (!this.disabledCurrent) return current > moment()
		    // return (current && current < moment(this.disabledCurrent).subtract(6, 'days').startOf('day')) || current > moment(this.disabledCurrent).add(6, 'days').endOf('day') || current > moment()
			return current && current > moment().endOf('day') || current < moment().subtract(7, 'day');
		},
		// 同步历史数据-结束
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
				
				// 排序的状态重置
				// that.r_sort_field = ''
				// that.r_sort_type = ''
				// that.rableTitle.forEach(res=>{
				// 	res.sort_status = 0
				// })
			}
			
			// 为了把选择账户下拉框与账户ID搜索框的数据进行整合，因为这两个请求字段是一样的
			let aaa_id = null
			if(that.r_adv_id_input && that.r_adv_id.length == 0){
				aaa_id = that.r_adv_id_input
			}
			else if(!that.r_adv_id_input && that.r_adv_id.length > 0){
				aaa_id = that.r_adv_id
			}
			else if(that.r_adv_id_input && that.r_adv_id.length > 0){
				// 不用去重，试了下，就算传重复的，后端那边会过滤
				let iii = JSON.stringify(that.r_adv_id) // 深拷贝
				let jjj = JSON.parse(iii)
				jjj.push(that.r_adv_id_input)
				aaa_id = jjj
			}
			
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				start_time: that.startTime.replace(/-/g, ''),
				end_time: that.endTime.replace(/-/g, ''),
				adv_id: aaa_id,
				admin_id: that.r_admin_id, // 选择投手
				
				content_channel: that.r_content_type,
				book_id: that.r_book_id,
			}
			// 如有排序字段就加上
			if(that.r_sort_field){ 
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			BDzhList(r_data).then(res=>{
				console.log('搜索',res);
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){ 
					let data = res.data.data.data
					data.forEach(res=>{
						res.checked = false // 用于多选和单选
						res.popover_clicked = false // 操作栏的气泡卡片
					})
					// 这个页面的选择框其实是没有相关功能的。所以这里就写这些。
					console.log("that.checkAll",that.checkAll)
					that.checkAll = false
					that.indeterminate = false
					that.selectedData = []
					
					that.search_button_loading = false
					that.$message.success('搜索成功');
					that.tableSumData = res.data.data.adv_sum
					that.table_total = res.data.data.total
					that.tableShowData = data
				}
				else {
					
					that.checkAll = false
					that.indeterminate = false
					that.search_button_loading = false
					
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
				
			})
			.catch(err=>{
				// 重置状态
				that.selectedData = []
				that.checkAll = false
				that.indeterminate = false
				
				that.search_button_loading = false
				
				that.$message.error('搜索失败，请检查网络状态')
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 点击投手
		clickFzr(e){
			console.log(e)
			let that = this
			this.selectedData = []
			this.selectedData.push(e)

			e.auth.forEach(res=>{
				let obj = {
					label: res.admin_name,
					key: res.admin_id
				}
				this.pl_select_admin.push(obj)
			})
			this.pl_modal = true
		},
		
		// 批量设置投手，选择投手
		handleChangeD(e){
			console.log(e);
			this.pl_value = e
			let ttt = true
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		// 批量设置投手弹窗确认按钮
		plOk(){
			let that = this
			if(that.pl_select_admin.length > 0){ // 得选择投手
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.bd_user_id)
				})
				console.log("i_data",i_data);
				
				accBDSetAdvUser({
					admin_id: a_data,
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					console.log("批量设置投手",res);
					that.selectedData = []
					that.plCancel()
					that.$message.success('设置成功');
					that.searchButton()
				})
			}
			else {
				this.$message.warning('请先选择投手');
			}
			
			
		},
		// 删除选择的投手
		delSelectAdmin(index){
			this.pl_select_admin.splice(index,1)
		},
		// 批量设置投手弹窗取消按钮
		plCancel(){
			if(this.pl_loading){
				return 
			}
			this.pl_select_admin = []
			this.pl_modal = false
			this.pl_value = undefined
		},
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			// console.log(that.r_sort_field);
			// console.log(that.r_sort_type);
			that.searchButton()
		},
		
		// 同步广告
		syncZhxxClick(item,type){
			let that = this
			console.log(item);
			if(type == 1){
				if(!that.search_button_loading){
					that.search_button_loading = true
					BDzhSyncAdv({
						bd_user_id: item.bd_user_id
					}).then(res=>{
						that.search_button_loading = false
						console.log("同步广告",res);
						if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){ 
							that.$message.success(res.data.msg);
							that.searchButton()
						}
						else {
							if(res.data.code === 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(`错误：${res.data.msg}`);
							}
						}
					})
					.catch(err=>{
						that.search_button_loading = false
					})
				}
				// else if(type == 4){ // 同步账户信息
					
				// }
			}
			else if(type == 5){ // 同步历史数据
				that.selectedData = []
				that.checkAll = false
				that.indeterminate = false
				that.tableShowData.forEach((res,index)=>{
					res.checked = false
				})
				that.selectedData.push(item)
				
				that.sync_modal = true
				
			}
		},
		
		// 同步历史数据
		syncOk(){
			let that = this
			
			that.sync_loading = true
			
			let a_ids = []
			
			console.log("that.selectedData",that.selectedData);
			that.selectedData.forEach((res,index)=>{
				a_ids.push(res.bd_user_id)
			})
			
			BDsyncPlanReport({
				start_date: that.startTime_sync,
				end_date: that.endTime_sync,
				
				bd_user_id: a_ids,
			}).then(res=>{
				console.log("同步历史数据",res);
				that.sync_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					console.log("同步历史数据",res);
					// that.$message.success('同步历史数据成功');
					that.searchButton()
					that.syncCancel()
					that.$confirm({
						title: '同步历史数据成功',
						icon:"exclamation-circle",
						class:'jlzh',//类名
						okText: "查看任务进度",
						cancelText: "取消",
						content: h => <div >点击按钮前往-同步任务列表，查看任务进度</div>,
						onOk() {
						  console.log('OK');
						  // that.$router.push({path: '/taskSync'});
						  const { href } = that.$router.resolve('/taskSync')
						  window.open(href, '_blank');
						},
						onCancel() {
						  console.log('Cancel');
						},
						
					});
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
			
		},
		syncCancel(){
			// if(this.sync_loading){
			// 	return
			// }
			
			// this.selectedData = []
			this.sync_modal = false
			
			this.sync_loading = false
		},
		
		// 批量操作
		handleButtonClick(e) {
		    console.log('click left button', e);
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
			if(this.selectedData.length > 0){
				let that = this
				if(e.key == '1'){ // 同步历史数据
					// that.search_button_loading = true
					that.sync_modal = true
				}
				else if(e.key == '7'){ // 设置推广内容
					that.$nextTick(()=>{
						that.$refs.getTgContent.plTg()
					})
					
				}
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		
		
		// 推广内容设置相关
		setAdvOk(){
			this.searchButton()
		},
		clickTgnr(item){
			let that = this
			
			that.$refs.getTgContent.clickTgnr(item)
			
		},
	},
	
}
</script>

<style scoped>

</style>